import type { ReactNode } from "react";
import { toast } from "./editor";
import { Icon } from "./ui";

/** A numbered step of a setup checklist: ticked when done, opening to its body, locked until the one before it. */
export function Step<K extends string>({ k, n, title, done, open, locked, lockedText, onToggle, children }: { k: K; n: number; title: string; done: boolean; open: boolean; locked?: boolean; lockedText?: string; onToggle: (k: K | null) => void; children: ReactNode }) {
  return (
    <div className={`setup-step${open ? " is-open" : ""}${done ? " is-done" : ""}`}>
      <button type="button" className="setup-step__head" aria-expanded={open} onClick={() => onToggle(open ? null : k)} disabled={locked && !done}>
        <span className="setup-step__mark" aria-hidden="true">{done ? <Icon.check /> : null}</span>
        <span className="setup-step__title">
          <span className="sr">Step {n}: </span>
          {title}
        </span>
        {locked && !done ? <small className="muted">{lockedText ?? `After step ${n - 1}`}</small> : <Icon.chevD />}
      </button>
      {open && <div className="setup-step__body">{children}</div>}
    </div>
  );
}

/** A value to copy (a link, a code), with its Copy button. */
export function CopyRow({ label, value }: { label: string; value: string }) {
  return (
    <div className="copy-value">
      <span className="muted">{label}</span>
      <code className="copy-value__text">{value}</code>
      <button type="button" className="btn btn--sm" onClick={() => void navigator.clipboard?.writeText(value).then(() => toast("Copied"), () => toast("Couldn't copy", "error"))}>
        <Icon.copy /> Copy
      </button>
    </div>
  );
}
